import { createSlice } from '@reduxjs/toolkit'
import colors from 'tailwindcss/colors'

import KinesisLogo from 'media/logos/kinesis_logo.png'

const shadeCodes = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950]

const defaultStyleConfig = {
    organizationId: 1,
    logo: KinesisLogo,
    primaryTailwindColorClass: "orange",
    anchorShade: 400,
    loadingScreenText: "Unlock your potential",
    loadingScreenLogoWhiteBackground: 0
}

const initialState = {
    styleConfig: defaultStyleConfig
}

const brandSlice = createSlice({
    name: 'brand',
    initialState,
    reducers: {
        // setBrandStyleConfig: (state, action) => { 

        //     // Verfiy anchor shade code is valid
        //     if (!shadeCodes.includes(action.payload.anchorShade)) action.payload.anchorShade = defaultStyleConfig.anchorShade

        //     state.styleConfig = action.payload 
        // },
        resetBrand: () => initialState
    },
});

// Brand Style Util Functions

export const GetPrimaryColorHex = (styleConfig, shadeModifier = 0) => {

    // Based on color palette found here: https://tailwindcss.com/docs/customizing-colors#default-color-palette

    const anchorIndex = shadeCodes.findIndex(shade => shade === styleConfig.anchorShade)
    const targetShade = shadeCodes[Math.min(Math.max(0, anchorIndex + shadeModifier), shadeCodes.length - 1)]

    switch (styleConfig.primaryTailwindColorClass) {
        case 'red': return colors.red[targetShade]
        case 'orange': return colors.orange[targetShade]
        case 'amber': return colors.amber[targetShade]
        case 'yellow': return colors.yellow[targetShade]
        case 'lime': return colors.lime[targetShade]
        case 'green': return colors.green[targetShade]
        case 'emerald': return colors.emerald[targetShade]
        case 'teal': return colors.teal[targetShade]
        case 'cyan': return colors.cyan[targetShade]
        case 'sky': return colors.sky[targetShade]
        case 'blue': return colors.blue[targetShade]
        case 'indigo': return colors.indigo[targetShade]
        case 'violet': return colors.violet[targetShade]
        case 'purple': return colors.purple[targetShade]
        case 'fuchsia': return colors.fuchsia[targetShade]
        case 'pink': return colors.pink[targetShade]
        case 'rose': return colors.rose[targetShade]
        case 'slate': return colors.slate[targetShade]
        case 'gray': return colors.gray[targetShade]
        case 'zinc': return colors.zinc[targetShade]
        case 'neutral': return colors.neutral[targetShade]
        case 'stone': return colors.stone[targetShade]
        default:
            console.warn(`Invalid color class: ${styleConfig.primaryTailwindColorClass}!! Defaulting to orange-400`)
            return colors.orange[400]
    }

}

export const GetProgramPhaseColorHex = (styleConfig, programPhaseKey) => {

    if (programPhaseKey === "no-season") return "#e5e7eb"
    if (programPhaseKey === "re-introduction") return GetPrimaryColorHex(styleConfig, -3)
    if (programPhaseKey === "reload") return GetPrimaryColorHex(styleConfig, -3)
    if (programPhaseKey === "off-season") return GetPrimaryColorHex(styleConfig, -2)
    if (programPhaseKey === "early-season") return GetPrimaryColorHex(styleConfig, -1)
    if (programPhaseKey === "in-season") return GetPrimaryColorHex(styleConfig)
    if (programPhaseKey === "competition") return GetPrimaryColorHex(styleConfig, 1)
    if (programPhaseKey === "championship") return GetPrimaryColorHex(styleConfig, 2)
    if (programPhaseKey === "post-race-deload") return GetPrimaryColorHex(styleConfig, -3)

    return "#fafafa"

}

export const {
    // setBrandStyleConfig,
    resetBrand
} = brandSlice.actions;

export default brandSlice.reducer;